import React, { FC, HTMLAttributes, useEffect, useState } from "react";

import ApiStateModal from "../../../components/reusable-ui/basic-modal";

import { MESSAGE_TYPE } from "../../../data/constants";
import "./style.scss";
import FileUploadModal from "./file-upload-modal";
import ReconReportsView from "./recon-reports-view";
import recon_reports_skeleton from "../../../assets/images/recon-reports-skeleton.gif";
import { useDispatch } from "react-redux";
import {
  getOrderwisePayoutData,
  getReconAggregationData,
  getUploadedReportsMetaData,
} from "../../../redux/slices";
import TopActionBar from "./top-action-bar";
import UploadedReportsView from "./uploaded-reports-view";
import { RECON_ORDER_TYPES } from "../../../data/accounting-constants";

const OnlineOrderReconciliation: FC<HTMLAttributes<HTMLDivElement>> = () => {
  const [apiStateModalData, setApiStateModalData] = useState<any>({
      show: false,
      type: "",
      mainText: "",
      subText: "",
    }),
    [isFileUploadModalOpen, setIsFileUploadModalOpen] =
      useState<boolean>(false),
    [showReconReports, setShowReconReports] = useState<boolean>(false),
    [loadingCounter, setLoadingCounter] = useState(0),
    [selectedAggregator, setSelectedAggregator] = useState(""); // show loader when loadingCounter > 0

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getUploadedReportsMetaData());
  }, []);

  const viewReconReports = (payload: any) => {
    fetchReconData(payload);
    setShowReconReports(true);
    setSelectedAggregator(payload.aggregatorType);
  };

  function showLoader() {
    setLoadingCounter((val) => val + 1); // increament loadingCounter
  }

  function hideLoader() {
    setLoadingCounter((val) => val - 1); // decrement loadingCounter
  }

  function fetchReconData(dataToPost: any) {
    const callback = (isSuccess: boolean) => {
      hideLoader();
    };
    // API call to fetch recon aggregation data
    showLoader();
    dispatch(getReconAggregationData({ dataToPost, callback }));

    // API call to fetch orderwise payout data for "unmatched" orders
    showLoader();
    dispatch(
      getOrderwisePayoutData({
        dataToPost: { ...dataToPost, orderType: RECON_ORDER_TYPES[1].type },
        callback,
      })
    );

    // API call to fetch orderwise payout data for "not found" orders
    showLoader();
    dispatch(
      getOrderwisePayoutData({
        dataToPost: { ...dataToPost, orderType: RECON_ORDER_TYPES[2].type },
        callback,
      })
    );
  }

  function renderSkeletonLoader() {
    return (
      <img
        src={recon_reports_skeleton}
        alt="skeleton"
        className="w-[calc(100%-40px)] bg-white m-20 mb-0"
      />
    );
  }

  function renderReconReports() {
    return loadingCounter > 0 ? (
      renderSkeletonLoader()
    ) : (
      <ReconReportsView
        onBackCtaClick={() => setShowReconReports(false)}
        aggregatorType={selectedAggregator}
      />
    );
  }

  return (
    <div className={`online-order-recon-container`}>
      <TopActionBar
        onApplyCtaClick={viewReconReports}
        setIsFileUploadModalOpen={setIsFileUploadModalOpen}
      />
      {showReconReports ? (
        renderReconReports()
      ) : (
        <UploadedReportsView handleViewReport={viewReconReports} />
      )}
      {isFileUploadModalOpen ? (
        <FileUploadModal onModalClose={() => setIsFileUploadModalOpen(false)} openStateModal={setApiStateModalData} />
      ) : null}
      {apiStateModalData?.show ? (
        <ApiStateModal
          modalType={apiStateModalData?.type}
          open={apiStateModalData?.show}
          handleClose={() => setApiStateModalData({ show: false })}
          mainText={apiStateModalData?.mainText || ""}
          subText={apiStateModalData?.subText || ""}
        ></ApiStateModal>
      ) : null}
    </div>
  );
};

export default OnlineOrderReconciliation;
